import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import Tooltip from '@/components/Tooltip';
import { CloseButton } from '@/components/ModalHoc';

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ModalHeader = _ref => {
  let {
    className,
    closeBtnClassName = '',
    heading,
    headingIcon = /*#__PURE__*/_jsx(_Fragment, {}),
    headingTooltip = '',
    customCloseButton,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("header", {
    className: clsx(styles.container, className || ''),
    children: [/*#__PURE__*/_jsxs("h3", {
      className: clsx(styles.heading, headingIcon ? styles['heading--hasIcon'] : ''),
      title: heading,
      children: [headingIcon, heading, headingTooltip && /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        className: styles.tooltip,
        content: headingTooltip,
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      })]
    }), children, customCloseButton ? customCloseButton : /*#__PURE__*/_jsx(CloseButton, {
      className: clsx(styles.close, closeBtnClassName)
    })]
  });
};

export default ModalHeader;